import { render, staticRenderFns } from "./EditContactComponent.vue?vue&type=template&id=3fab8564&"
import script from "./EditContactComponent.vue?vue&type=script&lang=js&"
export * from "./EditContactComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports